import MainContainer from "./Components/Maindiv"

function App() {
  return (<MainContainer />);
}

export default App;
